import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    constructor() {}
    setItem(key: string, value: any): void {
        try {
            const storageValue = typeof value === 'string' ? value : JSON.stringify(value);
            localStorage.setItem(key, storageValue);
        } catch (error) {
            console.error('Error saving to local storage', error);
        }
    }
    getItem<T>(key: string): T | null {
        try {
            const value = localStorage.getItem(key);
            if (!value) return null;
            try {
                return JSON.parse(value);
            } catch {
                return value as unknown as T;
            }
        } catch (error) {
            console.error('Error reading from local storage', error);
            return null;
        }
    }
    removeItem(key: string): void {
        localStorage.removeItem(key);
    }
    clear(): void {
        localStorage.clear();
    }
}
